var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { avatarHtml } from '@/support/String';
import { Event as EventModel } from '@/models/Event';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
import Summary from '@/views/Subjects/Summary';
let StudentOverviewTableDialog = class StudentOverviewTableDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedUser = null;
        this.activeTab = 'tab-students';
        this.selected = [];
        this.isMandatory = false;
        this.events = null;
        this.visibility = {
            search: false,
            checkboxes: this.detailedEvent.is_resetable,
        };
    }
    get tableOptions() {
        return {
            model: new EventModel().include('user').filter({ role: RolesEnum.STUDENT }).limit(300).showInvitedStudents(this.eventId || ''),
            name: {
                singular: this.$tc('roles.student', 1),
                plural: this.$tc('roles.student', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: (prop, user) => {
                        return avatarHtml(user.avatar);
                    },
                },
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    sortable: {
                        key: 'name',
                        order: 'ASC',
                    },
                },
                {
                    text: this.$t('roster.dialog.is_default'),
                    value: 'is_default',
                    transform: (prop, user) => {
                        return user.is_default ? this.$t('yes') : this.$t('no');
                    },
                },
                {
                    text: this.$t('roster.dialog.mandatoried'),
                    value: 'is_mandatory',
                    transform: (prop, user) => {
                        return user.is_mandatory ? this.$t('yes') : this.$t('no');
                    },
                },
            ],
            actions: [
                {
                    type: 'error',
                    label: 'error',
                    icon: 'error',
                    visible: (vue, event) => {
                        return !event.is_mandatory;
                    },
                    action: (vue, user) => {
                        this.selectedUser = user;
                        if (this.detailedEvent && this.detailedEvent.is_resetable) {
                            this.$store.dispatch('openDialog', this.dialogOptions);
                        }
                        else {
                            this.$store.dispatch('openDialog', this.dialogOptionsVisibleStudents);
                        }
                    },
                },
                {
                    type: 'restore',
                    label: 'restore',
                    icon: 'restore',
                    visible: (vue, event) => {
                        return event.is_mandatory;
                    },
                    action: (vue, user) => {
                        this.selectedUser = user;
                        if (this.detailedEvent && this.detailedEvent.is_resetable) {
                            this.$store.dispatch('openDialog', this.dialogOptions);
                        }
                        else {
                            this.$store.dispatch('openDialog', this.dialogOptionsVisibleStudents);
                        }
                    },
                },
            ],
            dropdown: [
                {
                    text: `${this.$t('actions.notObligate')}`,
                    icon: 'error',
                    action: (vm) => {
                        this.isMandatory = false;
                        this.$store.dispatch('openDialog', this.dialogOptionsMany);
                    },
                },
                {
                    text: `${this.$t('actions.obligate')}`,
                    icon: 'restore',
                    action: (vm) => {
                        this.isMandatory = true;
                        this.$store.dispatch('openDialog', this.dialogOptionsMany);
                    },
                },
            ],
        };
    }
    get dialogOptionsMany() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.isMandatory ? this.$tc('dialogOptions.obligate', 2, { item: this.$t('dialogOptions.item.students') }).toString() : this.$tc('dialogOptions.notObligate', 2, { item: this.$t('dialogOptions.item.students') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.yes').toString(),
                    action: () => {
                        if (!this.selected || !this.selected.length) {
                            return;
                        }
                        const payload = {
                            users: [],
                        };
                        this.selected.forEach((user) => {
                            payload.users.push({
                                id: user ? user.id : '',
                                is_mandatory: this.isMandatory,
                            });
                        });
                        new EventModel({ id: this.eventId })
                            .mandatory(payload)
                            .then((events) => {
                            this.studentDatatable ? this.studentDatatable.refresh() : null;
                            this.studentDatatable ? this.studentDatatable.resetSelected() : null;
                            this.resetSelectedStudents();
                        }).catch((error) => {
                            this.eventId = '';
                            let mandatoryError = false;
                            if (error.response && error.response.data.errors) {
                                Object.keys(error.response.data.errors).forEach((key) => {
                                    if (key === 'event_user.is_mandatory') {
                                        mandatoryError = true;
                                    }
                                });
                            }
                            if (mandatoryError) {
                                ErrorHandler.alert(this.$t('roster.dialog.mandatoryErrorMessage').toString(), this.$t('roster.dialog.mandatoryErrorTitle').toString());
                            }
                            else {
                                ErrorHandler.network(error);
                            }
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.studentDatatable ? this.studentDatatable.refresh() : null;
                        this.studentDatatable ? this.studentDatatable.resetSelected() : null;
                        this.resetSelectedStudents();
                    },
                },
            },
        };
    }
    get dialogOptionsVisibleStudents() {
        return {
            title: this.$t('event.edit.visibleStudents').toString(),
            text: '',
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
    get dialogOptions() {
        const user = this.selectedUser;
        return {
            title: user.name || this.$t('dialogOptions.confirmation').toString(),
            text: user && user.is_mandatory ? this.$tc('dialogOptions.notObligate', 1, { item: user.name }).toString() : this.$tc('dialogOptions.obligate', 1, { item: user.name }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.yes').toString(),
                    action: () => {
                        if (!user) {
                            return;
                        }
                        const payload = {
                            users: [
                                {
                                    id: user.id,
                                    is_mandatory: user.is_mandatory ? false : true,
                                },
                            ],
                        };
                        new EventModel({ id: this.eventId })
                            .mandatory(payload)
                            .then((events) => {
                            this.studentDatatable ? this.studentDatatable.refresh() : null;
                            this.resetSelected();
                        })
                            .catch((error) => {
                            this.eventId = '';
                            let mandatoryError = false;
                            if (error.response && error.response.data.errors) {
                                Object.keys(error.response.data.errors).forEach((key) => {
                                    if (key === 'event_user.is_mandatory') {
                                        mandatoryError = true;
                                    }
                                });
                            }
                            if (mandatoryError) {
                                ErrorHandler.alert(this.$t('roster.dialog.mandatoryErrorMessage').toString(), this.$t('roster.dialog.mandatoryErrorTitle').toString());
                            }
                            else {
                                ErrorHandler.network(error);
                            }
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.resetSelected();
                    },
                },
            },
        };
    }
    get studentDatatable() {
        const dataTable = this.$refs.studentDatatable;
        if (dataTable) {
            return dataTable;
        }
        return null;
    }
    dropdown() {
        return this.tableOptions.dropdown;
    }
    closeDialog() {
        this.$emit('close', false);
        this.resetSelected();
    }
    mounted() {
        //
    }
    resetSelectedStudents() {
        this.selected = [];
    }
    resetSelected() {
        this.selectedUser = null;
    }
    subjectsUpdated() {
        this.$emit('subjectsUpdated', true);
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], StudentOverviewTableDialog.prototype, "eventId", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof EventModel !== "undefined" && EventModel) === "function" ? _a : Object)
], StudentOverviewTableDialog.prototype, "detailedEvent", void 0);
StudentOverviewTableDialog = __decorate([
    Component({
        components: {
            DataTable,
            // SubjectOverview,
            Summary,
        },
    })
], StudentOverviewTableDialog);
export default StudentOverviewTableDialog;
